import { render, staticRenderFns } from "./PricingRangeTable.vue?vue&type=template&id=3bd73496&scoped=true&"
import script from "./PricingRangeTable.vue?vue&type=script&lang=js&"
export * from "./PricingRangeTable.vue?vue&type=script&lang=js&"
import style0 from "./PricingRangeTable.vue?vue&type=style&index=0&id=3bd73496&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd73496",
  null
  
)

export default component.exports